// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@-webkit-keyframes _2IILw{5%{opacity:1}50%{opacity:.35}95%{opacity:1}}@keyframes _2IILw{5%{opacity:1}50%{opacity:.35}95%{opacity:1}}._162ta{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;gap:16px;gap:1.6rem}._1rLXU{border-radius:1rem;height:48px;height:4.8rem;width:48px;width:4.8rem}._3oZ_u{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;gap:4px;gap:.4rem}._2hBX-{font-size:16px;font-size:1.6rem;font-weight:700;line-height:24px;line-height:2.4rem}._17z1-{color:#5e6e97;font-size:14px;font-size:1.4rem;font-weight:500;line-height:21px;line-height:2.1rem}", ""]);
// Exports
exports.locals = {
	"application": "_162ta",
	"application__logo": "_1rLXU",
	"application__details": "_3oZ_u",
	"application__name": "_2hBX-",
	"application__company_name": "_17z1-",
	"fading": "_2IILw"
};
module.exports = exports;
